import { TFunction } from 'i18next';

import { bpErrorsCodes } from 'activate-errors';
import { Invoice } from 'lane-shared/domains/billingPayments/types';

import { LONG_TOAST_DURATION } from '../constants';
import { MarkAsBilledResult } from './useMarkInvoiceAsBilled';

export async function confirmAndMarkAsBilled({
  invoice,
  markAsBilled,
  t,
}: {
  invoice: Invoice;
  markAsBilled: (invoice: Invoice) => Promise<MarkAsBilledResult>;
  t: TFunction;
}) {
  try {
    await window.Alert.confirm({
      title: t('abp.invoice.markAsBilledTitle'),
      message: t('abp.invoice.markAsBilledMessage'),
      confirmText: t('abp.actions.markAsBilled'),
    });
  } catch {
    return;
  }

  const result = await markAsBilled(invoice);

  if (result.status === 'billed') {
    await window.Toast.show(
      t('abp.invoice.markAsBilledSuccessToast'),
      LONG_TOAST_DURATION
    );

    return;
  }

  const message =
    result.error.kind === 'NOT_ISSUED'
      ? t(bpErrorsCodes.invoiceNotIssued.message)
      : result.error.message;

  await window.Toast.show(message, LONG_TOAST_DURATION);
}
